import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import Select from 'react-select';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadQADropdownData, loadReportingToDropdownData, loadTechnicalDropdownData, postAssignComplaintEscalationDatas, postComplaintEscalationDatas } from "../../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication';
import { ADDED_BY_ID } from "../../Constants";

const priorityOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
]

const AssignToComplaintModal = (props) => {
    let dispatch = useDispatch();
    const getComplaintData = props.getComplaintData;
    const singleComplaintEscalationData = props.singleComplaintEscalationData;
    const complaintId = props.complaintId;
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { technicalData } = useSelector((state) => state.data);
    const { QAData } = useSelector((state) => state.data);

    const [assignToData, setAssignToData] = useState({
        ComplaintID: complaintId,
        Priority: "",
        AssignedToUserID: null,
        TATInDays: null,
        AddedByID: ADDED_BY_ID
    });

    const [errors, setErrors] = useState({}); // Error state to store validation errors

    useEffect(() => {
        dispatch(loadReportingToDropdownData(assignToData.CompanyID));
    }, [dispatch, assignToData.CompanyID]);

    useEffect(() => {
        dispatch(loadTechnicalDropdownData());
        dispatch(loadQADropdownData());
    }, [])

    // useEffect(() => {
    //     if (complaintId && singleComplaintEscalationData) {

    //         console.log(complaintId, 'complaintId')
    //         setAssignToData(prevData => ({
    //             ...prevData,
    //             Priority: singleComplaintEscalationData[0]?.Priority || "",
    //             AssignedToUserID: singleComplaintEscalationData[0]?.AssignedToUserID || null,
    //             TATInDays: singleComplaintEscalationData[0]?.TATInDays || "",
    //         }));
    //     }
    // }, [dispatch, complaintId, singleComplaintEscalationData]);

    // Validate form fields
    const validateForm = () => {
        const newErrors = {};
        if (!assignToData.Priority) newErrors.Priority = "Priority is required.";
        if (!assignToData.AssignedToUserID) newErrors.AssignedToUserID = "Assigned To is required.";
        if (!assignToData.TATInDays) newErrors.TATInDays = "TAT (Days) is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission (add complaint escalation data)
    const addComplaintEscalationData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify({
                    ...assignToData,
                    TATInDays: parseInt(assignToData.TATInDays, 10) // Convert to integer
                }),
            };
            dispatch(postAssignComplaintEscalationDatas(requestOption, props.handleCloseAssignToModal, getComplaintData, complaintId, props.getComplaintData));
            console.log(assignToData, 'assignToData')
        }
    }

    // Clear error for specific field
    const clearError = (field) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[field];
            return newErrors;
        });
    };

    return (
        <Modal show={props.showAssignToModal} onHide={props.handleCloseAssignToModal} className='add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Assign To</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={5}>
                                <div>
                                    <label> {singleComplaintEscalationData[0]?.Status === 'Resolved' ? 'Assign To QA' : 'Assign To Technical'}</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        // value={technicalData.find(option => option.value === assignToData.AssignedToUserID)}
                                        // onChange={(selectedOption) => {
                                        //     setAssignToData(prevData => ({ ...prevData, AssignedToUserID: selectedOption.value }));
                                        //     clearError("AssignedToUserID");
                                        // }}
                                        // options={reportingToDropdown}
                                        value={(singleComplaintEscalationData[0]?.Status === 'Resolved' ? QAData : technicalData).find(option => option.value === assignToData.AssignedToUserID)}
                                        onChange={(selectedOption) => {
                                            setAssignToData(prevData => ({ ...prevData, AssignedToUserID: selectedOption.value }));
                                            clearError("AssignedToUserID");
                                        }}
                                        options={singleComplaintEscalationData[0]?.Status === 'Resolved' ? QAData : technicalData} // Condition-based options
                                        placeholder="Select"
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                    {errors.AssignedToUserID && <small className="text-danger">{errors.AssignedToUserID}</small>}
                                </div>
                            </Col>
                            <Col md={7}>
                                <div>
                                    <label className="p-2">Estimated Resolution Time (In Days) </label>
                                    <Form.Control
                                        type="number"
                                        min="0"  // Prevents negative input
                                        value={assignToData.TATInDays || ''}
                                        onChange={(e) => {
                                            const tat = e.target.value;
                                            setAssignToData(prevData => ({ ...prevData, TATInDays: tat }));
                                            if (errors.TATInDays) clearError("TATInDays");
                                        }}
                                    />
                                    {errors.TATInDays && <small className="text-danger">{errors.TATInDays}</small>}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div>
                                    <label>Priority </label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        value={priorityOptions.find(option => option.value === assignToData.Priority)}
                                        onChange={(selectedOption) => {
                                            setAssignToData(prevData => ({ ...prevData, Priority: selectedOption.value }));
                                            clearError("Priority");
                                        }}
                                        options={priorityOptions}
                                        placeholder="Select"
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                    {errors.Priority && <small className="text-danger">{errors.Priority}</small>}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseAssignToModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={addComplaintEscalationData} />
            </Modal.Footer>
        </Modal>
    );
}

export default AssignToComplaintModal;
